
import { BaseBackgroundEffect } from '@/render/background/BaseBackgroundEffect';
import { BackgroundContext } from '@/render/background/BackgroundEffect';

interface MeshPoint {
    x: number;
    y: number;
    vx: number;
    vy: number;
    color: string;
}

export class MeshGradientBackground extends BaseBackgroundEffect {
    private points: MeshPoint[] = [];

    private init(bc: BackgroundContext) {
        const count = bc.config.backgroundMeshPoints || 6;
        if (this.points.length === count) return;

        this.points = [];
        for (let i = 0; i < count; i++) {
            this.points.push({
                x: Math.random() * bc.width,
                y: Math.random() * bc.height,
                vx: (Math.random() - 0.5) * 2,
                vy: (Math.random() - 0.5) * 2,
                color: i % 2 === 0 ? bc.config.backgroundPrimaryColor : bc.config.backgroundSecondaryColor
            });
        }
    }

    public render(bc: BackgroundContext): void {
        const { ctx, width, height, config, time } = bc;
        this.init(bc);

        // Fill base color
        ctx.fillStyle = config.backgroundTertiaryColor;
        ctx.fillRect(0, 0, width, height);

        const speed = config.backgroundSpeed || 1.0;

        // Update and draw points
        this.points.forEach((p, i) => {
            if (config.backgroundAnimate) {
                p.x += p.vx * speed;
                p.y += p.vy * speed;

                if (p.x < 0 || p.x > width) p.vx *= -1;
                if (p.y < 0 || p.y > height) p.vy *= -1;
            }

            const color = i % 2 === 0 ? this.getPrimaryColor(bc) : this.getSecondaryColor(bc);
            
            const grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, width * 0.8);
            grad.addColorStop(0, color);
            grad.addColorStop(1, 'transparent');

            ctx.globalCompositeOperation = 'screen';
            ctx.fillStyle = grad;
            ctx.fillRect(0, 0, width, height);
        });
        
        ctx.globalCompositeOperation = 'source-over';
    }
}
